
import { HeartPulse, UserCheck, Share2 } from 'lucide-react';

export const FeaturesSection = () => {
  return (
    <section className="py-16 md:py-24 bg-emergency-50">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl font-bold mb-4 text-emergency-700">Your Complete Emergency Planning Solution</h2>
          <p className="text-lg text-muted-foreground">Everything you need to stay prepared for any situation</p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
          <div className="rounded-xl overflow-hidden shadow-md">
            <img 
              src="/lovable-uploads/51b8372c-a08d-4a25-b0aa-59c01ece7147.png" 
              alt="Emergency preparedness bag" 
              className="w-full h-64 object-cover"
            />
            <div className="p-6 bg-white">
              <h3 className="text-xl font-bold mb-2">Peace of Mind</h3>
              <p className="text-muted-foreground">Stop worrying about being unprepared. Give your family the peace of mind that comes from having an emergency plan ready—before you ever need it.</p>
            </div>
          </div>
          
          <div className="rounded-xl overflow-hidden shadow-md">
            <img 
              src="https://images.unsplash.com/photo-1434030216411-0b793f4b4173" 
              alt="Personalized emergency planning" 
              className="w-full h-64 object-cover"
            />
            <div className="p-6 bg-white">
              <h3 className="text-xl font-bold mb-2">Personalized Planning</h3>
              <p className="text-muted-foreground">Receive a customized emergency plan tailored to your specific needs, location, and family situation in just 15 minutes.</p>
            </div>
          </div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-white p-8 rounded-xl border border-border hover:shadow-md transition-shadow">
            <div className="w-14 h-14 rounded-full bg-emergency-100 flex items-center justify-center mb-6">
              <HeartPulse size={28} className="text-emergency-600" />
            </div>
            <h3 className="text-xl font-bold mb-3">Reduce Anxiety</h3>
            <p className="text-muted-foreground">Transform worries into confidence with a clear action plan for emergencies that helps you sleep better at night.</p>
          </div>
          
          <div className="bg-white p-8 rounded-xl border border-border hover:shadow-md transition-shadow">
            <div className="w-14 h-14 rounded-full bg-emergency-100 flex items-center justify-center mb-6">
              <UserCheck size={28} className="text-emergency-600" />
            </div>
            <h3 className="text-xl font-bold mb-3">Family-Specific Guidance</h3>
            <p className="text-muted-foreground">Get recommendations that account for your family's unique needs, including children, seniors, pets, and those with medical requirements.</p>
          </div>
          
          <div className="bg-white p-8 rounded-xl border border-border hover:shadow-md transition-shadow">
            <div className="w-14 h-14 rounded-full bg-emergency-100 flex items-center justify-center mb-6">
              <Share2 size={28} className="text-emergency-600" />
            </div>
            <h3 className="text-xl font-bold mb-3">Easy Sharing</h3>
            <p className="text-muted-foreground">Share your emergency plan instantly with family members to ensure everyone knows what to do when seconds count.</p>
          </div>
        </div>
      </div>
    </section>
  );
};
